import { html, ref } from '@microsoft/fast-element';
export const foundationIconTemplate = html `
  <template>
    <i
      ${ref('iElement')}
      class=${(x) => `fa-${x.name} fa-${x.size} fa-${x.variant}`}
      part=${(x) => `icon-${x.name}-${x.size}-${x.variant}`}
    >
      <slot></slot>
    </i>
  </template>
`;
